import { Props } from './types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Label = ({ htmlFor, noMargin = false, text }: Props) => {
  const marginClass = noMargin ? '' : 'mb-2';

  return (
    <label
      htmlFor={htmlFor}
      className={`block font-medium dark:text-uniform-gray-100 light:text-uniform-gray-900 tracking-tightest ${marginClass}`}>
      {text}
    </label>
  );
};

export default Label;
